import React, { ForwardedRef, ReactNode } from 'react';
import clsx from 'clsx';
import { useTab } from 'react-aria/useTabList';
import { useObjectRef } from 'react-aria/useObjectRef';
import { TabListState } from 'react-stately/useTabListState';
import { Node } from '@react-types/shared';
import styles from '@danske/sapphire-css/components/segmentedControl/segmentedControl.module.css';

export interface SegmentedTabProps<T> {
  isDisabled?: boolean;
  isActive?: boolean;
  children: ReactNode;
  state: TabListState<T>;
  item: Node<T>;
}
export const SegmentedTab = React.forwardRef(function SegmentedTab<T>(
  { isDisabled, isActive, children, state, item }: SegmentedTabProps<T>,
  forwardedRef: ForwardedRef<HTMLButtonElement>
) {
  const ref = useObjectRef(forwardedRef);
  const { tabProps } = useTab({ key: item.key }, state, ref);

  return (
    <button
      {...tabProps}
      ref={ref}
      className={clsx(styles['sapphire-segmented-control__button'], {
        [styles['sapphire-segmented-control__button--active']]: isActive,
        [styles['sapphire-segmented-control__button--disabled']]: isDisabled,
      })}
      type="button"
    >
      {children}
    </button>
  );
});
